import StaffList from "@/components/Staff/StaffList.vue";
import StaffEdit from "@/components/Staff/StaffEdit.vue";
import StaffFilter from "@/components/Staff/StaffFilter.vue";

export default [
    {
        path: 'staff',
        name: 'All Staff',
        redirect: "/staff/list",
        components: {
            page: StaffList,
        },
        meta: {
            requiresAuth: true
        },
        children: [
            {
                path: "filter",
                name: "Staff Filter",
                components: {
                    modal: StaffFilter
                }
            },
            {
                path: "list/:filter?",
                name: "Staff List",
                components: {
                    // ... NONE
                }
            },
            {
                path: "edit/:id",
                name: "Staff Edit",
                components: {
                    modal: StaffEdit,
                }
            }
        ]
    }
];